function formatDmsPart(digits: string): string {
	if (digits.length === 0) return '';

	let out = digits.slice(0, 2);
	if (digits.length <= 2) return out;

	out += '° ';
	out += digits.slice(2, 4);
	if (digits.length <= 4) return out;

	out += "' ";
	out += digits.slice(4, 6);
	if (digits.length <= 6) return out;

	out += '.';
	out += digits.slice(6, 8);
	if (digits.length >= 8) out += '"';
	return out;
}

export function formatCoordenadaDmsMask(raw: string): string {
	const digits = raw.replace(/\D/g, '').slice(0, 16);
	if (digits.length === 0) return '';

	const sDigits = digits.slice(0, 8);
	const wDigits = digits.slice(8);

	let out = 'S ' + formatDmsPart(sDigits);

	if (wDigits.length > 0) {
		out += ' - W ';
		out += formatDmsPart(wDigits);
	}

	return out;
}

export const COORDENADA_DMS_MASK_MAX_LENGTH = 35;
